import type { UseGrowthBook } from './growthbook/generated'

type EvalFeature = UseGrowthBook['evalFeature']

type GetRouteConfigArgs = {
  id: string | undefined
  funnelId: string | undefined
  evalFeature: EvalFeature
}

type RouteConfig = {
  configKey: string
  isOn: boolean
}

const evalDeclaredFeature = (
  evalFeature: EvalFeature,
  configKey: string
): RouteConfig | undefined => {
  const result = evalFeature(configKey)

  // Flags are resolved against the live payload. Anything the payload does not
  // know about is not declared.
  return result && result.source !== 'unknownFeature'
    ? { configKey, isOn: result.on }
    : undefined
}

/**
 * Resolves the GrowthBook flag gating a step from its identifier, preferring the
 * funnel specific flag (`m01_energy_pitch_enabled`) over the one shared across
 * funnels (`onboarding_energy_pitch_enabled`). A step with neither flag declared
 * in GrowthBook is always enabled.
 */
export const getRouteConfig = ({
  id,
  funnelId,
  evalFeature,
}: GetRouteConfigArgs): RouteConfig | undefined => {
  if (!id) {
    return undefined
  }

  const funnelConfig = funnelId
    ? evalDeclaredFeature(evalFeature, `${funnelId}_${id}_enabled`)
    : undefined

  return (
    funnelConfig ?? evalDeclaredFeature(evalFeature, `onboarding_${id}_enabled`)
  )
}

export const getRouteEventName = (id: string | undefined) => {
  return id ? `onboarding_${id}` : undefined
}
